import React, { useCallback, useEffect, useMemo, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
// Icons
import { Search, Plus, Trash2 } from "lucide-react";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import DeleteModal from "Common/DeleteModal";
import Modal from "Common/Components/Modal";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import LoadingCounter from "Common/Components/LoadingCounterProps";

const Cutie = () => {
  const [data, setData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [eventData, setEventData] = useState<any>();
  const [reload, setreload] = useState<boolean>();
  const [load, setload] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState("");
  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const [productListYearCropValue, setproductListYearCropValue] = useState<any>(
    localStorage.getItem("crop_year_id")
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        // پارامترهای پایه
        const params: any = {
          sort_by: "updated_at",
          sort_order: "desc",
        };
        setData([]);
        if (productListYearCropValue && productListYearCropValue !== "null") {
          params.crop_year_id = productListYearCropValue;
          const res = await axios.get(
            "https://api.havirkesht.ir/purity-price/",
            {
              params,
            }
          );
          const items = res?.data?.items || [];
          setData(items);
          setload(items.length <= 0);
        }
      } catch (error: any) {
        console.error("Error fetching data:", error);
        setErrorMessage(
          error?.message ? "" : "خطایی رخ داده است. لطفاً مجدداً تلاش کنید."
        );
        setload(true);
      }
    };
    fetchData();
  }, [reload, productListYearCropValue]);

  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.id) {
      setEventData(cell.id);
    }
  };

  const handleDelete = async () => {
    if (eventData) {
      const res = await axios.delete(
        `https://api.havirkesht.ir/purity-price/${eventData}`
      );
      if (res.status === 200) {
        toast.success("عملیات حذف با موفقیت انجام شد");
        setreload(!reload);
      } else {
        toast.error("مشکل در حذف دیتا");
      }

      setDeleteModal(false);
      setEventData(null);
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    validation.handleSubmit();
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      base_purity: "",
      base_purity_price: "",
      price_difference: "",
    },
    validationSchema: Yup.object({
      base_purity: Yup.number().required("لطفاًعیار مبنا: را وارد کنید"),
      base_purity_price: Yup.number().required(
        "لطفاً قیمت عیار مبنا را وارد کنید"
      ),
      price_difference: Yup.number().required("لطفاً تفاوت قیمت  را وارد کنید"),
    }),
    onSubmit: async (values) => {
      setload(true);
      try {
        const newData = {
          ...values,
          crop_year_id: Number(productListYearCropValue),
        };
        const res = await axios.post(
          "https://api.havirkesht.ir/purity-price/",
          newData
        );

        if (res.status === 201) {
          toast.success("اطلاعات با موفقیت ثبت شد");
          setreload(!reload);
        }
        setload(false);
      } catch (error) {
        setload(false);
        toast.error("خطا در ثبت اطلاعات");
      } finally {
        toggle();
      }
    },
  });

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      validation.resetForm();
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);
  // cell: ({ getValue }: { getValue: () => any }) => {
  //   const value = getValue();
  //   return value ? value.toLocaleString("fa-IR") : "0";
  // },
  const columns = useMemo(
    () => [
      {
        header: "سال زارع",
        accessorKey: "crop_year_name",
        enableColumnFilter: false,
      },
      {
        header: "عیار مبنا",
        accessorKey: "base_purity",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: "قیمت عیار مبنا",
        accessorKey: "base_purity_price",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },

      {
        header: "تفاوت قیمت",
        accessorKey: "price_difference",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },

      {
        header: "تاریخ ایجاد",
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "عملیات",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <Link to="#" onClick={() => onClickDelete(cell.row.original)}>
              <Trash2 className="size-4" />
            </Link>
          </div>
        ),
      },
    ],
    []
  );
  const formatNumber = (num: number | string) => {
    if (num === null || num === undefined || num === "") return "";
    const numStr = num.toString()?.replace(/,/g, "");
    return numStr?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const parseFormattedNumber = (formattedNum: string) => {
    return formattedNum?.replace(/,/g, "");
  };
  return (
    <React.Fragment>
      <BreadCrumb pageTitle="ثبت   قیمت عیار" title=" هاویر کشت " />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer
        position="top-center"
        closeButton={false}
        limit={1}
        rtl={true}
        className="font-Bold text-lg"
      />

      {errorMessage && <div>{errorMessage}</div>}
      <div className="card" id="employeeTable rtl">
        <div className="card-body ">
          <div className="flex items-center gap-3 mb-4">
            <h6 className="text-15 grow">
              مجموع عیار ها (<b className="total-Employs">{data?.length}</b>)
            </h6>
            <div className="shrink-0">
              <Link
                to="#!"
                onClick={toggle}
                type="button"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600"
              >
                <span className="align-middle rtl">ثبت قیمت عیار جدید</span>{" "}
                <Plus className="inline-block size-4 rtl" />
              </Link>
            </div>
          </div>
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={true}
              columns={columns}
              isGlobalFilter={true}
              data={data}
              customPageSize={10}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={data ? 0 : 15}
              text={errorMessage ? errorMessage : "داده ای در جدول وجود ندارد"}
            />
          )}
        </div>
      </div>

      <Modal
        show={show}
        onHide={toggle}
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
        >
          <Modal.Title className="text-16"> تعیین قیمت عیار</Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form
            className="create-form"
            id="create-form"
            onSubmit={validation.handleSubmit}
          >
            <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
              <div className="xl:col-span-11 dark:text-white text-gray-800 space-y-4">
                {/* سال زراعی */}
                <div className="flex flex-col items-center space-y-4">
                  {/* عیار مبنا */}
                  <div className="flex items-center w-full max-w-md">
                    <label
                      htmlFor="base_purity"
                      className="text-base font-medium w-32 flex-shrink-0"
                    >
                      عیار مبنا:
                    </label>
                    <input
                      type="text"
                      id="base_purity"
                      name="base_purity"
                      className="flex-1 p-2 border border-gray-200 rounded bg-white text-gray-900"
                      placeholder="عیار مبنا"
                      onChange={(e) => {
                        const rawValue = parseFormattedNumber(e.target.value);
                        if (rawValue === "" || /^\d+$/.test(rawValue)) {
                          validation.setFieldValue(
                            "base_purity",
                            rawValue === "" ? "" : parseInt(rawValue, 10)
                          );
                        }
                      }}
                      value={formatNumber(validation.values.base_purity)}
                      onKeyDown={(e) => {
                        if (
                          !/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight|Tab/.test(
                            e.key
                          )
                        ) {
                          e.preventDefault();
                        }
                      }}
                      inputMode="numeric"
                    />
                  </div>
                  {validation.touched.base_purity &&
                    validation.errors.base_purity && (
                      <p className="text-red-400 mr-24 mt-2">
                        {validation.errors.base_purity}
                      </p>
                    )}

                  {/* قیمت عیار مبنا */}
                  <div className="flex items-center w-full max-w-md">
                    <label
                      htmlFor="base_purity_price"
                      className="text-base font-medium w-32 flex-shrink-0"
                    >
                      قیمت عیار مبنا:
                    </label>
                    <input
                      type="text"
                      id="base_purity_price"
                      name="base_purity_price"
                      className="flex-1 p-2 border border-gray-200 rounded bg-white text-gray-900"
                      placeholder="قیمت عیار مبنا به ریال"
                      onChange={(e) => {
                        const rawValue = parseFormattedNumber(e.target.value);
                        if (rawValue === "" || /^\d+$/.test(rawValue)) {
                          validation.setFieldValue(
                            "base_purity_price",
                            rawValue === "" ? "" : parseInt(rawValue, 10)
                          );
                        }
                      }}
                      value={formatNumber(validation.values.base_purity_price)}
                      onKeyDown={(e) => {
                        if (
                          !/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight|Tab/.test(
                            e.key
                          )
                        ) {
                          e.preventDefault();
                        }
                      }}
                      inputMode="numeric"
                    />
                  </div>
                  {validation.touched.base_purity_price &&
                    validation.errors.base_purity_price && (
                      <p className="text-red-400 mr-24 mt-2">
                        {validation.errors.base_purity_price}
                      </p>
                    )}

                  {/* تفاوت قیمت */}
                  <div className="flex items-center w-full max-w-md">
                    <label
                      htmlFor="price_difference"
                      className="text-base font-medium w-32 flex-shrink-0"
                    >
                      تفاوت قیمت:
                    </label>
                    <input
                      type="text"
                      id="price_difference"
                      name="price_difference"
                      className="flex-1 p-2 border border-gray-200 rounded bg-white text-gray-900"
                      placeholder="تفاوت قیمت هر عیار به ریال"
                      onChange={(e) => {
                        const rawValue = parseFormattedNumber(e.target.value);
                        if (rawValue === "" || /^\d+$/.test(rawValue)) {
                          validation.setFieldValue(
                            "price_difference",
                            rawValue === "" ? "" : parseInt(rawValue, 10)
                          );
                        }
                      }}
                      value={formatNumber(validation.values.price_difference)}
                      onKeyDown={(e) => {
                        if (
                          !/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight|Tab/.test(
                            e.key
                          )
                        ) {
                          e.preventDefault();
                        }
                      }}
                      inputMode="numeric"
                    />
                  </div>
                  {validation.touched.price_difference &&
                    validation.errors.price_difference && (
                      <p className="text-red-400 mr-24 mt-2">
                        {validation.errors.price_difference}
                      </p>
                    )}
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="flex justify-center p-4 border-t dark:border-zink-500">
          <button
            type="button"
            onClick={handleClick}
            className="px-4 py-2 mt-4 font-bold justify-end text-white bg-blue-500 rounded hover:bg-blue-600"
          >
            {load ? "در حال ارسال ..." : "  ثبت اطلاعات"}
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default Cutie;
